import React from 'react'
import { useDrawing } from '../../context/DrawingContext'
import styles from './BrushSettings.module.css'

const BrushSettings = () => {
  const { state, dispatch } = useDrawing()

  const handleBrushSizeChange = (size) => {
    dispatch({ type: 'SET_BRUSH_SIZE', payload: parseInt(size) })
  }

  const handleOpacityChange = (opacity) => {
    dispatch({ type: 'SET_OPACITY', payload: parseInt(opacity) })
  }

  return (
    <div className={styles.brushSettings}>
      <div className={styles.setting}>
        <label className={styles.label}>
          크기: {state.brushSize}px
        </label>
        <input
          type="range"
          min="1"
          max="50"
          value={state.brushSize}
          onChange={(e) => handleBrushSizeChange(e.target.value)}
          className={styles.slider}
        />
        <div className={styles.sizePreview}>
          <div
            className={styles.sizeIndicator}
            style={{
              width: `${Math.min(state.brushSize * 2, 40)}px`,
              height: `${Math.min(state.brushSize * 2, 40)}px`,
              backgroundColor: state.color
            }}
          />
        </div>
      </div>

      <div className={styles.setting}>
        <label className={styles.label}>
          투명도: {state.opacity}%
        </label>
        <input
          type="range"
          min="1"
          max="100"
          value={state.opacity}
          onChange={(e) => handleOpacityChange(e.target.value)}
          className={styles.slider}
        />
        <div className={styles.opacityPreview}>
          <div
            className={styles.opacityIndicator}
            style={{
              backgroundColor: state.color,
              opacity: state.opacity / 100
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default BrushSettings